var ClassBuilder = /** @class */ (function () {
    function ClassBuilder(className) {
        this.className = className;
    }
    /**
     * Creates a new ClassBuilder instance
     *
     * @param className
     *
     * @return {ClassBuilder}
     */
    ClassBuilder.createClass = function (className) {
        return new ClassBuilder(className);
    };
    /**
     * Adds a class to the class builder
     *
     * @param {string} className
     *
     * @return {ClassBuilder}
     */
    ClassBuilder.prototype.add = function (className) {
        this.className += " ".concat(className);
        return this;
    };
    /**
     * Adds a class to the class builder when the given expression is true
     *
     * @param {string} className
     *
     * @param {boolean} expression
     *
     * @return {ClassBuilder}
     */
    ClassBuilder.prototype.addIf = function (className, expression) {
        if (expression) {
            this.add(className);
        }
        return this;
    };
    /**
     * Adds the first given class to the class builder when the given expression is true otherwise it adds the second one
     *
     * @param {string} className1
     *
     * @param {string} className2
     *
     * @param {boolean} expression
     *
     * @return {ClassBuilder}
     */
    ClassBuilder.prototype.addIfElse = function (className1, className2, expression) {
        if (expression) {
            this.add(className1);
        }
        else {
            this.add(className2);
        }
        return this;
    };
    /**
     * Returns the build class
     *
     * @return {string}
     */
    ClassBuilder.prototype.build = function () {
        return this.className;
    };
    return ClassBuilder;
}());
export { ClassBuilder };
export default ClassBuilder;
